import { isValidElement } from 'react'

import { Close as CloseIcon } from '@mui/icons-material'
import { Dialog, Divider } from '@mui/material'

import './DefaultModal.css'

const normalizeRichText = (value) => {
	if (Array.isArray(value)) {
		return value
	}

	if (typeof value === 'string' && value.trim()) {
		return [[{ text: value.trim() }]]
	}

	return []
}

const RichTextBlock = ({ value, className }) => {
	if (isValidElement(value)) {
		return value
	}

	const lines = normalizeRichText(value)

	if (!lines.length) {
		return null
	}

	return (
		<>
			{lines.map((line, lineIndex) => (
				<span key={`${className}-${lineIndex}`} className={`${className}__line`}>
					{line.map((segment, segmentIndex) => {
						const toneClass = segment?.tone ? `${className}__segment--${segment.tone}` : ''
						const weightClass = segment?.weight === 'strong' ? `${className}__segment--strong` : ''

						return (
							<span key={`${className}-${lineIndex}-${segmentIndex}`} className={[`${className}__segment`, toneClass, weightClass].filter(Boolean).join(' ')}>
								{segment?.text || ''}
							</span>
						)
					})}
				</span>
			))}
		</>
	)
}

const resolveIcon = (icon) => {
	if (isValidElement(icon)) {
		return icon
	}

	if (typeof icon === 'function') {
		const IconComponent = icon
		return <IconComponent />
	}

	return null
}

const DefaultModal = ({
	open,
	handleClose,
	title,
	subtitle,
	icon,
	contentTitle,
	contentDescription,
	action,
	children,
	maxWidth = 'sm',
	showClose = true,
	paperClassName = '',
	actionAlign = 'center',
	actionClassName = '',
	contant = null,
	dialogProps
}) => {
	const iconNode = resolveIcon(icon)
	const normalizedActionAlign = ['left', 'center', 'right'].includes(actionAlign) ? actionAlign : 'center'
	const actionsClassName = ['default-modal__actions', `default-modal__actions--${normalizedActionAlign}`, actionClassName].filter(Boolean).join(' ')
	const mergedPaperClassName = ['default-modal__paper', paperClassName].filter(Boolean).join(' ')

	return (
		<Dialog
			open={true}
			//onClose={handleClose}
			fullWidth
			maxWidth={maxWidth}
			disableEscapeKeyDown
			PaperProps={{
				className: mergedPaperClassName,
			}}
			{...dialogProps}
		>
			<div className="default-modal__shell">
				{showClose ? (
					<button type="button" className="default-modal__close" onClick={handleClose} aria-label="Fechar modal">
						<CloseIcon />
					</button>
				) : null}

				<div className="default-modal">
					{title || subtitle ? (
						<div className="default-modal__header">
							{title ? <><h2 className="default-modal__header-title">{title}</h2><Divider /></>: null}
							{subtitle ? <p className="default-modal__header-subtitle">{subtitle}</p> : null}
						</div>
					) : null}

					{iconNode || contentTitle || contentDescription ? (
						<div className="default-modal__content-shell">
							{iconNode ? <div className="default-modal__icon">{iconNode}</div> : null}

							{contentTitle ? (
								<div className="default-modal__content-title">
									<RichTextBlock value={contentTitle} className="default-modal__content-title" />
								</div>
							) : null}

							{contentDescription ? <p className="default-modal__content-description">{contentDescription}</p> : null}
						</div>
					) : null}

					{children ? <div className="default-modal__body">{children}</div> : null}

					{action ? <div className={actionsClassName}>{action}</div> : null}
				</div>
			</div>
		</Dialog>
	)
}

export default DefaultModal